import { render, staticRenderFns } from "./locator.vue?vue&type=template&id=10bd00df&scoped=true&lang=pug"
import script from "./locator.vue?vue&type=script&lang=js"
export * from "./locator.vue?vue&type=script&lang=js"
import style0 from "./locator.vue?vue&type=style&index=0&id=10bd00df&prod&lang=stylus"
import style1 from "./locator.vue?vue&type=style&index=1&id=10bd00df&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bd00df",
  null
  
)

export default component.exports